import React from 'react';
import FontAwesome from 'react-fontawesome';
import Modal from 'react-modal';

import './EmmaNewsletterForm.sass';

interface OwnProps {
    isOpen: boolean;
    /** Callback to be called to close this modal form */
    onRequestClose: () => void;
    isMobile: boolean;  // This may be better off coming from the display state in redux, fine the way it is for now
}

const EmmaNewsletterForm: React.StatelessComponent<OwnProps> = (props: OwnProps) => {
    const { isMobile, isOpen, onRequestClose } = props;
    return (
        <Modal
            appElement={document.getElementById('app')}
            closeTimeoutMS={150}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            style={{
                content: { // tslint:disable:object-literal-sort-keys
                    position: 'fixed',
                    left: '50%',
                    right: 'auto',
                    top: '50%',
                    bottom: 'auto',
                    transform: 'translate(-50%,-50%)',
                    width: isMobile ? '80%' : '40%',
                    height: '90%'
                } // tslint:enable:object-literal-sort-keys
            }}
        >
            <FontAwesome
                size="2x"
                name="times-circle"
                onClick={onRequestClose}
                style={{
                    position: 'absolute',
                    right: isMobile ? '25px' : '40px',
                    zIndex: 70
                }}
            />
            <div
                style={{
                    WebkitOverflowScrolling:'touch',
                    height: '100%',
                    overflow: 'auto'
                }}
            >
                <iframe
                    scrolling={navigator.userAgent.includes('iPhone') ? 'no' : 'yes'}
                    src="https://signup.e2ma.net/signup/1767572/1740192/"
                    className="emma-signup"
                />
            </div>
        </Modal>
    );
};

export default EmmaNewsletterForm;



// WEBPACK FOOTER //
// ./src/components/global/application/EmmaNewsletterForm.tsx